<template>
  <app-card>
    <v-row class="pl-4 pr-2 justify-space-between">
      <div class="align-self-center">
        <span>จำนวนรายการ </span>
        <span class=" primary--text">{{ list.length }}</span>
        <span> รายการ</span>
      </div>
      <div class="py-3 text-right">
        <v-pagination
          v-model="pageIndex"
          class="d-inline-flex"
          :length="totalPage"
          :total-visible="7"
          circle
          @input="onChangePage"
        />
      </div>
    </v-row>

    <div>
      <v-fade-transition>
        <v-overlay :value="overlay" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-fade-transition>
      <div v-if="list.length > 0">
        <v-card
          v-for="(item, index) in list"
          :key="index"
          class="pa-3 mx-1 my-3"
          elevation="4"
        >
          <v-row>
            <v-col cols="12" sm="6">
              <div>
                <span class="font-weight-bold">เขียนเมื่อ </span>
                <span>{{ item[`leaveAssignDate${$lang}`] }}</span>
                <span> : </span>
                <span>{{ item.leaveOrderID }}</span>
                <span> - </span>
                <span>{{ item[`leaveTypeName${$lang}`] }}</span>
              </div>

              <div>
                <span class="font-weight-bold">วันที่ขอลา </span>
                <span>{{ item[`leaveBeginDate${$lang}`] }}</span>
                <span> - </span>
                <span>{{ item[`leaveFinishDate${$lang}`] }}</span>
                <span> จำนวน </span>
                <span>{{ item.leaveAmountDayText }}</span>
              </div>

              <div>
                <span class="font-weight-bold">วิธีส่งใบลา </span>
                <span>{{ item.approveFlagName }}</span>
              </div>

              <div>
                <span class="font-weight-bold">สถานะ </span>
                <v-chip class="white--text my-1" :color="item.color" small>
                  {{ item[`leaveStatusName${$lang}`] }}
                  <span>{{ item[`empApproveName${$lang}`] }} </span>
                </v-chip>
              </div>
            </v-col>

            <v-col>
              <div v-if="item.leaveStatusID === 'B'" class="error--text">
                <div>ตีกลับเมื่อ {{ item[`backDate${$lang}`] }}</div>
                <div>เหตุผล {{ item.backDescription }}</div>
                <div>โดย {{ item[`backEmployeeName${$lang}`] }}</div>
              </div>

              <div>
                <v-btn
                  class="teal white--text ma-1"
                  small
                  depressed
                  @click="onOpenLeaveDocument(item)"
                >
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>
                  เปิดดูใบลา
                </v-btn>

                <v-btn
                  v-if="item.docFileName"
                  class="ma-1"
                  small
                  depressed
                  dark
                  @click="onOpenAttachedDocument(item)"
                >
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>
                  <span class="px-1">
                    เปิดดูเอกสารแนบ
                  </span>
                </v-btn>

                <v-btn
                  v-if="item.processApproveFlag"
                  class="pink darken-3 white--text ma-1"
                  :to="
                    `/leave/pending/${$guid}/order/${item.leaveOrderID}/timeline`
                  "
                  small
                  depressed
                >
                  <v-icon class="pr-1" small>mdi-timeline-clock-outline</v-icon>
                  ขั้นตอนการอนุญาต
                </v-btn>

                <v-btn
                  v-if="
                    item.leaveStatusID === 'W' || item.leaveStatusID === 'B'
                  "
                  class="amber darken-2 white--text ma-1"
                  small
                  depressed
                  @click="onEditLeave(item)"
                >
                  <v-icon class="pr-1" small>mdi-pencil</v-icon>
                  แก้ไขใบลา
                </v-btn>
                <v-btn
                  v-if="item.cancelFlag"
                  class="red white--text ma-1"
                  small
                  depressed
                  @click="onClickCancel(item)"
                >
                  <v-icon class="pr-1" small>mdi-trash-can-outline</v-icon>
                  ต้องการยกเลิกรายการ
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div v-else class="text-center grey--text">
        ไม่มีข้อมูล
      </div>
    </div>

    <div class="py-3 text-right">
      <v-pagination
        v-model="pageIndex"
        class="d-inline-flex"
        :length="totalPage"
        :total-visible="7"
        circle
        @input="onChangePage"
      />
    </div>

    <v-dialog v-model="dialog.show" max-width="500">
      <v-card class="py-2">
        <v-card-title class="headline">ต้องการยกเลิกรายการนี้?</v-card-title>

        <v-card-text class="mb-4">
          <span class="text-body-1">
            คุณต้องการยกเลิกรายการ
            {{ dialog.item.leaveOrderID }} ใช่หรือไม่</span
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-4 mt-n8">
            <v-btn
              color="error"
              class="mr-2"
              outlined
              @click="dialog.show = false"
            >
              ยกเลิก
            </v-btn>

            <v-btn color="success" class="mr-2" @click="onConfirmCancel()">
              ยืนยัน
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <v-dialog v-model="loading1" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังบันทึก...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card> </v-dialog
    ></v-col>
  </app-card>
</template>

<script>
export default {
  data() {
    return {
      overlay: false,
      dialog: {
        show: false,
        item: {}
      },
      pageIndex: 1,
      totalPage: 1,
      loading1: false,
      list: []
    }
  },

  watch: {
    $route() {
      this.onSearchBegin()
    }
  },

  async mounted() {
    await this.onSearch()
  },

  methods: {
    async onSearchBegin() {
      this.$route.query.page = 1
      this.pageIndex = 1
      await this.onSearch()
    },

    async onSearch() {
      this.overlay = true
      let result = []
      try {
        result = await this.apiPostSearchPending()
        this.totalPage = result.totalPage
        this.list = result.items
      } catch (e) {
        console.log(e.response || e)
      }
      this.overlay = false
    },

    async onOpenLeaveDocument(item) {
      let path = `/pdf?store=leave/getLeaveDocumentDownload&FileType=pdf&guid=${this.$guid}&leaveOrderID=${item.leaveOrderID}`
      window.open(path)
    },

    async onOpenAttachedDocument(item) {
      try {
        const payload = {
          leaveOrderID: item.leaveOrderID,
          docFileName: item.docFileName
        }
        const res = await this.$store.dispatch(
          'leave/getAttachedDocumentDownload',
          payload
        )

        var fileURL = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/pdf' })
        )
        var link = document.createElement('a')
        link.href = fileURL
        link.download = item.docFileName
        link.click()
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onEditLeave(item) {
      let leaveType = ''
      switch (item.leaveTypeID) {
        case 1:
          leaveType = 'buss'
          break
        case 2:
          leaveType = 'sick'
          break
        case 4:
          leaveType = 'deliver'
          break
        case 5:
          leaveType = 'ordain'
          break
        case 6:
          leaveType = 'relax'
          break
        case 8:
          leaveType = 'study'
          break
        case 10:
          leaveType = 'study'
          break
        case 11:
          leaveType = 'study'
          break
        case 14:
          leaveType = 'study'
          break
        case 15:
          leaveType = 'study'
          break
        case 16:
          leaveType = 'soldier'
          break
        case 17:
          leaveType = 'married'
          break
        case 18:
          leaveType = 'hutch'
          break
        case 20:
          leaveType = 'dharma'
          break
        case 22:
          leaveType = 'wife'
          break
        case 23:
          leaveType = 'study'
          break
        case 24:
          leaveType = 'study'
          break
        case 25:
          leaveType = 'study'
          break
        case 27:
          leaveType = 'graduate'
          break
        case 99:
          leaveType = 'cancel'
          break
      }
      window.open(`/leave/form/${leaveType}/${this.$guid}/${item.leaveOrderID}`)
    },

    onClickCancel(item) {
      this.dialog.show = true
      this.dialog.item = item
    },

    async onChangePage() {
      this.$route.query.page = this.pageIndex
      await this.onSearch()
    },

    async onConfirmCancel() {
      this.dialog.show = false
      this.loading1 = true
      try {
        const payload = {
          LeaveOrderID: this.dialog.item.leaveOrderID,
          EmployeeID: this.$guid,
          LeaveStatusID: 'C'
        }

        await this.$store.dispatch('leave/putCancelForm', payload)
        await this.onSearch()
        this.loading1 = false
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiPostSearchPending() {
      const query = this.$route.query
      const body = {
        EmployeeID: this.$guid,
        LeaveStatusID: query.leaveStatus || 0,
        LeaveTypeID: query.leaveType || 0,
        Month: query.leaveMonth || 0,
        Year: query.leaveYear
          ? parseInt(query.leaveYear) + 543
          : new Date().getMonth() + 1 >= 10
          ? new Date().getFullYear() + 1 + 543
          : new Date().getFullYear() + 543,
        PageIndex: parseInt(query.page) - 1 || 0,
        RowsPerPage: 10
      }
      try {
        const res = await this.$store.dispatch('leave/postSearchPending', body)
        if (res.data?.data[0].hasOwnProperty('items')) {
          const list = res.data?.data[0].items.map(item => {
            item.leaveAssignDateTha = this.$dateFormatByLang(
              item.leaveAssignDate,
              {
                format: 'DD MMMM YYYY',
                addUnit: 'y',
                addValue: 543
              }
            )
            item.leaveAssignDateEng = this.$dateFormat(item.leaveAssignDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })
            item.leaveBeginDateTha = this.$dateFormatByLang(
              item.leaveBeginDate,
              {
                format: 'DD MMMM YYYY',
                addUnit: 'y',
                addValue: 543
              }
            )
            item.leaveBeginDateEng = this.$dateFormat(item.leaveBeginDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })
            item.leaveFinishDateTha = this.$dateFormatByLang(
              item.leaveFinishDate,
              {
                format: 'DD MMMM YYYY',
                addUnit: 'y',
                addValue: 543
              }
            )
            item.leaveFinishDateEng = this.$dateFormat(item.leaveFinishDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })

            if (item.backDate) {
              item.backDateTha = this.$dateFormatByLang(item.backDate, {
                format: 'DD MMMM YYYY, HH:mm น.',
                addUnit: 'y',
                addValue: 543
              })
              item.backDateEng = this.$dateFormat(item.backDate, {
                format: 'DD MMMM YYYY, HH:mm',
                locale: 'en'
              })
            }
            return item
          })
          return {
            items: list,
            totalPage: res.data?.data[0].hasOwnProperty('countrow')
              ? Math.ceil(parseInt(res.data?.data[0].countrow) / 10)
              : 0
          }
        }
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
        this.totalPage = 0
        this.list = []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
